import SupportLink from "../../../components/SupportLink";
import NamedEntity from "../../../interfaces/NamedEntity";
import ScoreReportChart from "./ScoreReportChart";
import {
	DraftScoreNormViewModel,
	DraftScoreViewModel,
	WritingAnalysisViewModel,
} from "../scoreReportApiSlice";

interface ScoresProps {
	analysis: WritingAnalysisViewModel;
	draftScore: DraftScoreViewModel;
	showDraftNorm: boolean;
	draftNorm: DraftScoreNormViewModel;
	normSupportLinkSuffix: string;
	genre: NamedEntity;
	className?: string;
}

export default function ScoreReportScores(props: ScoresProps) {
	if (!props.draftScore) {
		return (
			<>
				<h1>Scores</h1>
				<p>This draft has not been scored.</p>
			</>
		);
	}

	return (
		<section className={props.className}>
			<h1>Scores</h1>
			<div className="flex mt-4">
				<div className="w-1/4">
					<p>
						This essay’s total score is{" "}
						<span className="text-xl ml-2 font-semibold text-primary-600">
							{props.draftScore.totalScore}
						</span>
					</p>
					{props.showDraftNorm && (
						<div>
							<p className="mt-4">
								Percentile Rank is{" "}
								<span className="text-lg bold ml-2">
									{props.draftNorm.percentileRank}
								</span>
							</p>
							<p>
								Stanine is{" "}
								<span className="text-lg bold ml-2">{props.draftNorm.stanine}</span>
							</p>
							<p className="mt-4">
								<SupportLink
									id="percentile-stanine-link"
									article={props.normSupportLinkSuffix}>
									Click here
								</SupportLink>{" "}
								to learn more about percentile ranks and stanines.
							</p>
						</div>
					)}
					<p className="mt-4">
						The essay was scored by PEG, the automated essay scorer, according to the
						scoring standard for your level.
					</p>
				</div>
				<div className="w-3/4 h-full mx-8">
					<ScoreReportChart
						analysis={props.analysis}
						draftScore={props.draftScore}
						isConstructedResponse={props.genre.id === 5 ? true : false}
					/>
				</div>
			</div>
		</section>
	);
}
